// extracted by mini-css-extract-plugin
export var progressContainer = "_ix-0";